export default __webpack_public_path__ + "static/media/ErrorPages.c2f418f8.svg";